"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _bluebird = require("bluebird");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
require("core-js");
require("./config/firebase");
var _react = _interopRequireDefault(require("react"));
var _AppRegistry = _interopRequireDefault(require("react-native-web/dist/exports/AppRegistry"));
var _reactRouterDom = require("react-router-dom");
var _history = require("browser/history");
var _reactIntl = require("react-intl");
var _utils = require("browser/app/utils/utils");
var _en = _interopRequireDefault(require("react-intl/locale-data/en"));
var _es = _interopRequireDefault(require("react-intl/locale-data/es"));
var _registerFirebaseServiceWorker = require("./register-firebase-service-worker");
var _device = require("shared-libs/models/device");
var _deviceInfoProvider = require("browser/app/utils/device-info-provider");
require("../../../vendor/jquery.resize");
require("styles/app.scss");
var _rootNavigator = require("browser/app/pages/root-navigator");
var _apis = _interopRequireDefault(require("./models/apis"));
var _messages = _interopRequireDefault(require("./messages"));
var _PollingAppStatus = require("browser/contexts/app-status/PollingAppStatus");
var _componentsContext = require("browser/contexts/components/components-context");
var _index = _interopRequireDefault(require("browser/components/index"));
var _storyboardPlan = require("shared-libs/models/types/storyboard/storyboard-plan");
var _formulas = require("shared-libs/helpers/formulas");
var _uiPropMappingContext = require("shared-libs/components/context/ui-prop-mapping-context");
var _uiPropMapping = require("browser/contexts/prop-mapping/ui-prop-mapping");
var _flagsmith = _interopRequireDefault(require("flagsmith"));
// global imports

// CSS import

// app import

// Minimum time offset before we apply a correction to returned Dates
var MINIMUM_OFFSET_MS = 1750;
global.MEMORY_LIMITED = false;
(0, _device.registerDeviceInfoProvider)(new _deviceInfoProvider.WebDeviceInfoProvider());
(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray2["default"])(_en["default"]), (0, _toConsumableArray2["default"])(_es["default"])));
var locale = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage || 'en-US';
(0, _bluebird.config)({
  // Enable warnings
  warnings: false,
  // Enable long stack traces
  longStackTraces: true,
  // Enable cancellation
  cancellation: true,
  // Enable monitoring
  monitoring: true
});
var App = function App() {
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    locale: locale,
    messages: (0, _utils.flattenMessages)(_messages["default"][locale])
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Router, {
    history: _history.browserHistory
  }, /*#__PURE__*/_react["default"].createElement(_componentsContext.ComponentsContext.Provider, {
    value: {
      components: _index["default"],
      platform: _storyboardPlan.PlatformType.WEB
    }
  }, /*#__PURE__*/_react["default"].createElement(_uiPropMappingContext.UIPropMappingContext.Provider, {
    value: {
      getPropMappingStrategy: _uiPropMapping.getPropMappingStrategy
    }
  }, /*#__PURE__*/_react["default"].createElement(_PollingAppStatus.PollingAppStatus, null, /*#__PURE__*/_react["default"].createElement(_rootNavigator.RootNavigator, null))))));
};

// register the app
_AppRegistry["default"].registerComponent('App', function () {
  return App;
});
var registerApplicationContextAndStart = function registerApplicationContextAndStart(offset) {
  _formulas.FormulaRegistry.registerApplicationContext({
    getDeeplinkHost: function getDeeplinkHost() {
      return _apis["default"].WEBAPP_URL;
    },
    getLocale: function getLocale() {
      return navigator.language;
    },
    getPlatform: function getPlatform() {
      return (0, _utils.getPlatform)();
    },
    getTruetimeOffset: function getTruetimeOffset() {
      return offset;
    },
    getStore: function getStore() {
      return _apis["default"].getStore();
    }
  });
  console.log("Setting truetime offset to ".concat(offset));
  _AppRegistry["default"].runApplication('App', {
    initialProps: {},
    rootTag: document.getElementById('react-app')
  });
};
registerApplicationContextAndStart(0);
(0, _registerFirebaseServiceWorker.registerFirebaseServiceWorker)();